<template>
  <section v-if="stories.length" id="stories" class="travel-stories-section">
    <v-container>
      <p>Travel Stories</p>
      <h2>Stories from {{ eventTitle }}</h2>
      <div class="story-track">
        <component
          :is="story.route ? 'router-link' : 'a'"
          v-for="story in stories"
          :key="story.id"
          :to="story.route"
          :href="story.route ? undefined : `#chapter-${story.id}`"
          class="story-card"
        >
          <span>{{ story.dayLabel || `Chapter ${story.chapterNumber}` }}</span>
          <h3>{{ story.title }}</h3>
          <p v-if="story.summary || story.subtitle">{{ story.summary || story.subtitle }}</p>
          <strong>Read the story <v-icon small>mdi-arrow-right</v-icon></strong>
        </component>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'TravelStoriesSection',
  props: {
    stories: { type: Array, default: () => [] },
    eventTitle: { type: String, default: 'the Journey' },
  },
};
</script>

<style scoped>
.travel-stories-section { background: #0b0b0b; border-top: 1px solid #282828; padding: 72px 0; scroll-margin-top: 68px; }
.travel-stories-section > .container > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2rem, 5vw, 3.4rem); margin: 0 0 28px; }
.story-track { display: grid; gap: 18px; grid-auto-columns: minmax(280px, 390px); grid-auto-flow: column; overflow-x: auto; padding: 2px 2px 18px; scroll-snap-type: x mandatory; }
.story-card { background: linear-gradient(145deg, #171717, #0b0b0b); border: 1px solid #303030; border-radius: 12px; color: inherit; min-height: 260px; padding: 26px; scroll-snap-align: start; text-decoration: none; }
.story-card:hover, .story-card:focus { border-color: #a8612d; transform: translateY(-2px); }
.story-card > span { color: #f0b13c; font-size: .75rem; font-weight: 900; text-transform: uppercase; }
.story-card h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 1.65rem; line-height: 1.15; margin: 12px 0; }
.story-card p { color: #bdbdbd; line-height: 1.6; }
.story-card strong { color: #ef7777; display: block; margin-top: 22px; }
.story-card .v-icon { color: currentColor; }
</style>
